import styles from './styles.module.scss';

interface Props {
    content: string;
}

function NoticeContent({ content }:Props) {
  return (<div className={styles.wrapper}
               dangerouslySetInnerHTML={{ __html: content }} />);
}

export default NoticeContent;
